import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import type { TitlePartProps } from "./Title.d";

export const TitlePart = (props: ComponentProps<PartData>) => {
  const { preabmbleType, margin, title, preamble } =
    (props.data as TitlePartProps) ?? {};

  let sectionClass = "article-header";
  if (preabmbleType === "light") {
    sectionClass = "news-article-header";
  }

  return (
    <header className={sectionClass}>
      <h1 className={margin}>{title}</h1>

      {preamble && <p className="text-ingress">{preamble}</p>}
    </header>
  );
};

export default TitlePart;
